export default __webpack_public_path__ + "static/media/ge-ab.b64c76be.svg";